import React, { createContext } from 'react';
import Toast, { ToastType } from './Toast';

export const ToastContext = createContext({
    showToast: (type: ToastType, message: string, duration: number) => { },
});

export const useToast = () => React.useContext(ToastContext);
